import { render, staticRenderFns } from "./SupplierDescription.vue?vue&type=template&id=1943e151"
import script from "./SupplierDescription.vue?vue&type=script&lang=js"
export * from "./SupplierDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports